import { TAppState } from '../../types';
import { EPaymentInitSource } from '../../types/microfrontends/paymentWidget';
import { selectPaymentInitSource } from './selectPaymentInitSource';

/**
 * Функция определяет, что чекаут открыт со страницы ЛК
 */
export const selectIsLkPaymentInitSource = (state: TAppState): boolean => {
  const paymentInitSource = selectPaymentInitSource(state)!;

  return [
    EPaymentInitSource.LkRealtorPackage,
    EPaymentInitSource.LkRealtorCustomPackage,
    EPaymentInitSource.LkRealtorSubscription,
    EPaymentInitSource.LkRealtorPersonalPackage,
    EPaymentInitSource.LkRealtorPersonalSubscription,
    EPaymentInitSource.LkRealtorSmartPackage,
  ].includes(paymentInitSource);
};
